// Normalizes a user-entered first name for storage and display: trims
// surrounding whitespace and capitalizes the first letter, leaving the rest
// as typed (so names like "Mc, "d'Ávila" or "JP" aren't mangled). Empty /
// whitespace-only input returns "".
export function capitalizeName(raw: string | null | undefined): string {
  const trimmed = (raw ?? "").trim();
  if (!trimmed) return "";
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
}
